'use strict';

var _ = require('underscore');
var isSimpleObject = require('./isSimpleObject');

/**
 * Remove keys containing empty objects and undefined values
 * @param {Object} object - input object
 * @returns {Object} - cleaned up object
 */

module.exports = function(object) {
	return _(object).omit(function(value) {
		return isSimpleObject(value) ? _(value).isEmpty() : _(value).isUndefined();
	});
};
